import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { forwardRef } from 'react';
import { ICON_DEFAULT_SIZE, ICON_DEFAULT_SPIN } from './Icon.constants';
import { IconRoot } from './Icon.styled';
// Component.
// -----------------------------------------------------------------------------
const Icon = forwardRef(({ icon, size = ICON_DEFAULT_SIZE, spin = ICON_DEFAULT_SPIN, ...rest }, ref) => (_jsx(IconRoot, { ref: ref, size: size, spin: spin, title: rest.title || icon.iconName, ...rest, children: _jsx(FontAwesomeIcon, { icon: icon }) })));
// Component configuration.
// -----------------------------------------------------------------------------
Icon.displayName = 'Icon';
export default Icon;
//# sourceMappingURL=Icon.js.map